/**
 * 智慧校园接口
**/

import toApi from "../index.js";
import qs from "qs";
import crossRequestHandle from "../../utils-khfw/crosRequestHandler";

const RequestTC = function (obj) {
  sessionStorage.needConsole = 1;
  const query = obj.params ? "?" + qs.stringify(obj.params) : "";
  return crossRequestHandle({
    method: "post",
    data: {
      intername: "addressListV7.url", // 7.0:addressListV7.url ||  6.0:aamif.url
      requestUri: obj.url + query,
      requestType: obj.method,
      data: obj.data || "null",
    },
  });
};

const zhxyRequest = function (obj) {
  const query = obj.params ? "?" + qs.stringify(obj.params) : "";
  let url =obj.is_d?"https://zhxy-gateway-7.d.huijiaoyun.com"+ obj.url + query:"https://zhxy-gateway-7.huijiaoyun.com" + obj.url + query;
  return toApi({
    url: url,
    method: obj.method,
    data: obj.data
  });
};

const request = function (obj) {
  const query = obj.params ? "?" + qs.stringify(obj.params) : "";
  let url
  if(sessionStorage.platformCode=='420100'){
    url =obj.is_d?"https://zhxy-gateway-7.d.huijiaoyun.com"+ obj.url + query:"https://zhxy-gateway-7.huijiaoyun.com" + obj.url + query;
  }else{
    // 智慧校园接口通过网关调取
    if(sessionStorage.zhxyGatewayUrl){
      url = sessionStorage.zhxyGatewayUrl + obj.url + query;
    }else{
      url ="https://zhxy-gateway-7.huijiaoyun.com" + obj.url + query;
    }
  }
  return toApi({
    url: url,
    method: obj.method,
    data: obj.data
  });
};

const api = {
     //获取智慧校园本地配置信息
     zhxyGatewayUrl(params) {
      return zhxyRequest({
        url:'/serv-platform/api/common/getSSLLocalConfigInfo',
        method: "get",
        params,
      })
    },
    //获取学年学期
    getSemesterList(params) {
      return request({
        url: `/app-calendar/remote/api/semester/getSemesterList`,
        method: "get",
        params,
        // is_d: true,
      })
    },
    //课程类型
    getCourseTypeList(params) {
      return request({
        url: `/app-elective/remote/api/setting/courseTypeList`,
        method: "get",
        params,
      })
    },
    //教师考勤统计
    teacherAttendance(params) {
      return request({
        url: `/app-elective/remote/api/statistics/teacher/attendance`,
        method: "get",
        params,
      });
    },
    //课程考勤统计 or 教师考勤统计-查看详情
    teacherCourseAttendance(params) {
      return request({
        url: `/app-elective/remote/api/statistics/course/attendance`,
        method: "get",
        params,
      });
    },
    //学生分布统计
    studentClassStatistics(params) {
      return request({
        url: `/app-elective/remote/api/statistics/class`,
        method: "get",
        params,
      })
    },
    //学生分布统计-查看详情
    studentCourseStatistics(params) {
      return request({
        url: `/app-elective/remote/api/statistics/student/course`,
        method: "get",
        params,
      })
    },
    //学生考勤统计
    classAttendanceStatistics(params) {
      return request({
        url: `/app-elective/remote/api/statistics/class/attendance`,
        method: "get",
        params,
      })
    },
    //获取机构参与统计-查看详情，课程开班统计，教师课时统计-查看详情
    handleCourseList(params) {
      return request({
        url:`/app-elective/remote/api/statistics/course`,
        method: "get",
        params,
      });
    },
    //学生报名详情
    handleStudentDetails(params) {
      return request({
        url:`/app-elective/remote/api/statistics/student/course`,
        method: "get",
        params,
      });
    },
    //机构课程统计列表
    handleExternalList(params) {
      return request({
        url:`/app-elective/remote/api/statistics/external/course`,
        method: "get",
        params,
      });
    },
    //学生考勤统计-查看详情, 课程出勤统计-查看详情
    handleStudentAttendanceDetails(params) {
      return request({
        url:`/app-elective/remote/api/statistics/student/attendance`,
        method: "get",
        params,
      });
    },
    //学校-查询延时课表信息
    schoolHandleTimetable(params) {
      return request({
        url:'/app-elective/remote/api/statistics/timetable',
        method: "get",
        params,
      });
    },
    //学校-课程整体情况统计 课程建设情况/教师参与情况/学生参与情况
    schoolOverallStatistics(params) {
      return request({
        url:'/app-elective/remote/api/statistics/schoolOverall',
        method: "get",
        params,
      });
    },
    //学校-本学期课后服务开展情况
    schoolClassSituationStatistics(params) {
      return request({
        url:'/app-elective/remote/api/statistics/classSituation',
        method: "get",
        params,
      });
    },
    //学校-课程资源建设量
    schoolCourseSituationStatistics(params) {
      return request({
        url:'/app-elective/remote/api/statistics/courseSituation',
        method: "get",
        params,
      });
    },
    //学校-学生考勤详情
    schoolStudentDetailStatistical(params){
      return request({
        url:'/app-elective/remote/api/statistics/courseUserListPaging',
        method:'get',
        params,
        // is_d: true,
      })
    },
    // 机构-延时课表
    handleTimetable(params) {
      return request({
          url:'/app-elective/remote/api/statistics/org/timetable',
          method: "get",
          params,
      });
    },
     // 获取学期周次信息
     getWeekInfo(params){
       return request({
         url:'/app-elective/remote/api/statistics/getWeekInfo',
         method: "get",
         params,
        //  is_d: true,
       });
     },
    // 机构-延时课表-学校下拉框
    getTimeTableSchoolList(params){
      return request({
        url:'/app-elective/remote/api/statistics/school/list',
        method: "get",
        params,
      });
    },
    // 机构-延时课表-课程下拉框
    getTimeTableCourseList(params){
      return request({
        url:'/app-elective/remote/api/statistics/course/list',
        method: "get",
        params,
      });
    },
     //延时课表（学校）
     handleSchoolTimetable(params) {
       return request({
         url:'/app-elective/remote/api/statistics/school/timetable',
         method: "get",
         params,
        //  is_d: true,
       });
     },
     //延时课表（班级））
     handleClassTimetable(params) {
      return request({
        url:'/app-elective/remote/api/statistics/class/timetable',
        method: "get",
        params,
        // is_d: true,
      });
    },
    // 机构-教师考勤统计
    getOrgTeacherAttendance(params){
      return request({
        url:'/app-elective/remote/api/statistics/org/teacher/attendance',
        method: "get",
        params,
      });
    },
    // 机构-教师考勤统明细
    getOrgTeacherAttendanceDetail(params){
      return request({
        url:'/app-elective/remote/api/statistics/org/teacher/attendance/detail',
        method: "get",
        params,
      });
    },
     // 机构-开课列表查询
     getOrgCourseApplyList(params){
      return request({
        url:'/app-elective/remote/api/statistics/org/courseApplyList',
        method: "get",
        params,
        // is_d: true,
      });
    },

     // 机构-开课列表导出
    getOrgExportCourseApplyList(params){
      return request({
        url:'/app-elective/remote/api/statistics/org/exportCourseApplyList',
        method: "get",
        params,
        // is_d: true,
      });
    },

    // 校本选课-开课详情
    getCourseApplyMsg(data) {
      return request({
        url: '/app-elective/remote/api/apply/getCourseApplyMsg',
        method: 'post',
        data,
        // is_d: true,
      });
    },
    // 选课
    selectCourse(data){
      return request({
        url: '/app-elective/remote/api/apply/selectCourse',
        method: 'post',
        data,
        // is_d: true,
      });
    },
    // 取消选课
    dropCourse(data){
      return request({
        url: '/app-elective/remote/api/apply/dropCourse',
        method: 'post',
        data,
        // is_d: true,
      });
    },
    // 待选课程
    waitingList(data){
      return request({
        url: '/app-elective/remote/api/apply/waitingList',
        method: 'post',
        data,
      });
    },
    // 已选课程
    selectedList(data){
      return request({
        url: '/app-elective/remote/api/apply/selectedList',
        method: 'post',
        data,
        // is_d: true,
      });
    },



    // 获取老师班级
    Teacherclass(params) {
      return RequestTC({
        url: "/user/api/org/get-edu-child-list",
        method: "get",
        params: params,
      });
    },
    //  // 获取下级组织列表
    //  eduGetschool(params) {
    //   return RequestTC({
    //     url: "/user/api/org-tree/get-child-list",
    //     method: "get",
    //     params: params,
    //   });
    // },
      // 获取下级组织列表
       eduGetschool(params) {
        return RequestTC({
          url: "/user/api/org-tree/get-child-list",
          method: "get",
          params: params,
        });
      },
}

export default api; 